import { gql } from '@apollo/client';
import { Point } from './types';

export interface FetchSavedVersionTrajectoryResponse {
    fetchSavedVersionTrajectory: Point[];
}

export interface FetchSavedVersionTrajectoryVariables {
    versionId: number;
}

export const FETCH_SAVED_VERSION_TRAJECTORY = gql`
    mutation FetchSavedVersionTrajectory($versionId: Long!) {
        fetchSavedVersionTrajectory(versionId: $versionId) {
            lat
            lng
        }
    }
`;
